import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const CustomButtonWrapper = styled.button<{
  buttonType: 'confirm' | 'cancel' | string;
  fullWidth: boolean;
  fontSize: string;
  fontFamily: string;
  borderColor: string;
  iconDirection: string;
  justify: string;
  disabled: boolean;
}>`
  width: ${(props) => (props.fullWidth ? '100%' : 'auto')};
  display: flex;
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: center;
  flex-direction: ${(props) =>
    props.iconDirection ? props.iconDirection : 'row'};
  gap: calc(${theme.space_size} / 2);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  font-family: ${(props) => props.fontFamily};
  border-radius: 8px;
  padding: 6px 16px;
  width: 80px;
  min-width: 80px;
  height: 32px;
  background-color: ${(props) =>
    props.buttonType === 'confirm'
      ? `${theme.colours.blackText}`
      : `${theme.colours.white}`};
  cursor: pointer;
  color: ${(props) =>
    props.buttonType === 'confirm'
      ? `${theme.colours.white}`
      : `${theme.colours.blackText}`};
  border: none;
  span {
    .icon {
      width: 11px;
      height: 11px;
      svg {
        width: 100%;
      }
    }
  }
`;
